/* TODO: t() */
import React, { useState, useCallback } from 'react';
import { View, StyleSheet } from 'react-native';

import ClickAway from './ClickAway';
import { themeColors } from './Constants';
import { IconButton } from '.';
import { SketchPicker } from 'react-color';
import { RGBColor } from '../../types/shared/Account';
import getColorString from '../../support/helpers/getColorString';

type Props = {
  style?: StyleSet;
  isDisabled?: boolean;
  selectedColor: RGBColor;
  handleChange?: (color: RGBColor) => void;
};

function ColorPicker(props: Props) {
  let { style, isDisabled, selectedColor, handleChange } = props;
  let [isPickerVisible, setPickerVisibility] = useState(false);

  let onPickerPress = useCallback(() => {
    setPickerVisibility((isPickerVisible) => !isPickerVisible);
  }, []);

  return (
    <View
      style={[
        style,
        styles.root,
        { zIndex: isPickerVisible ? 3 : 0, position: 'relative' },
      ]}
    >
      <IconButton
        iconName="colorPalette"
        tooltip="Change Color"
        iconSize="M"
        onPress={onPickerPress}
        isDisabled={isDisabled}
      />
      <View
        style={[
          styles.colorBox,
          {
            backgroundColor: selectedColor
              ? getColorString(selectedColor)
              : 'black',
          },
        ]}
      />
      {isPickerVisible && (
        <ClickAway onClickAway={onPickerPress}>
          <View style={styles.picker}>
            <SketchPicker
              color={selectedColor}
              onChange={(color) =>
                handleChange ? handleChange(color.rgb) : null
              }
            />
          </View>
        </ClickAway>
      )}
    </View>
  );
}

let styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  picker: {
    position: 'absolute',
    bottom: 0,
    left: 64,
  },
  colorBox: {
    width: 20,
    height: 32,
    borderRadius: 3,
    marginLeft: 5,
    borderColor: themeColors.borderGrey,
    borderWidth: 2,
  },
});

export default ColorPicker;
